<template>
  <div class="loading-status">
    <div>
      <Icons
        path="outline/spinner"
        spin
        size="32"
        class="mb-24"
      />
      <h2 class="loading-status__title">{{ isRefund ? '환불이' : '결제가' }} 진행 중입니다</h2>
      <p class="loading-status__desc">잠시만 기다려 주세요.</p>
    </div>
  </div>
</template>
<script setup lang="ts">
const { isRefund } = withDefaults(
  defineProps<{
    isRefund?: boolean
  }>(),
  {
    isRefund: false
  }
)
</script>
<style scoped lang="scss">
.loading-status {
  height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  .loading-status__title {
    font-size: 18px;
    font-weight: 600;
    color: $gray-700;
  }
  .loading-status__desc {
    padding: 8px;
    color: $gray-400;
  }
}
.fail-text {
  font-size: 14px;
  color: $gray-400;
  text-align: center;
}
</style>
